import gql from 'graphql-tag';

const cancelledGuaranteePurchasesAuditsQuery = gql`
  query cancelledPurchaseAudits(
      $cancelledPurchaseId: Int!
      $startDate: String
      $endDate: String
    ) {
    cancelledPurchaseAudits(
      cancelledPurchaseId: $cancelledPurchaseId
      startDate: $startDate
      endDate: $endDate
      ) {
      changeset
      createdAt
      event
      id
      itemType
      timeStamp
      versionAuthor
      whodunnit
    }
  }
`;

export default cancelledGuaranteePurchasesAuditsQuery;
